import { render, staticRenderFns } from "./VideoHeroSection.vue?vue&type=template&id=6804ce5a&"
import script from "./VideoHeroSection.vue?vue&type=script&lang=js&"
export * from "./VideoHeroSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports